import React from 'react'

interface SelectionCheckboxProps {
    id: number
    isSelected: boolean
    onSelectionChange: (id: number, checked: boolean) => void
    disabled?: boolean
}

const SelectionCheckbox: React.FC<SelectionCheckboxProps> = ({
    id,
    isSelected,
    onSelectionChange,
    disabled = false
}) => {
    return (
        <div className="absolute bottom-2 left-2 z-10">
            <div className="mr-3">
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => {
                        e.stopPropagation();
                        onSelectionChange(id, e.target.checked);
                    }}
                    disabled={disabled}
                    className="w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2"
                />
            </div>
        </div>
    )
}

export default SelectionCheckbox